import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "ss-login" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-lg-8 ant-col-xl-8" }
const _hoisted_4 = { class: "ui-login" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ui-dados-login" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Bem-vindo!")
], -1)
const _hoisted_9 = {
  key: 1,
  class: "ant-row"
}
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "ui-label-login" }, "Código Identificação", -1)
const _hoisted_12 = { class: "ant-input-affix-wrapper ss-login-input" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-prefix" }, [
  /*#__PURE__*/_createElementVNode("span", {
    type: "user",
    role: "img",
    "aria-label": "user",
    class: "anticon anticon-user"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      focusable: "false",
      class: "",
      "data-icon": "user",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      viewBox: "64 64 896 896"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" })
    ])
  ])
], -1)
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "ui-label-login" }, "E-mail", -1)
const _hoisted_17 = { class: "ant-input-affix-wrapper ss-login-input" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-prefix" }, [
  /*#__PURE__*/_createElementVNode("span", {
    type: "user",
    role: "img",
    "aria-label": "user",
    class: "anticon anticon-user"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      focusable: "false",
      class: "",
      "data-icon": "user",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      viewBox: "64 64 896 896"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M858.5 763.6a374 374 0 00-80.6-119.5 375.63 375.63 0 00-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 00-80.6 119.5A371.7 371.7 0 00136 901.8a8 8 0 008 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 008-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" })
    ])
  ])
], -1)
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "ui-label-login" }, "Senha", -1)
const _hoisted_22 = { class: "ant-input-affix-wrapper ss-login-input" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "ant-input-prefix" }, [
  /*#__PURE__*/_createElementVNode("span", {
    type: "user",
    role: "img",
    "aria-label": "user",
    class: "anticon anticon-password"
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      focusable: "false",
      class: "",
      "data-icon": "lock",
      width: "1em",
      height: "1em",
      fill: "currentColor",
      "aria-hidden": "true",
      viewBox: "64 64 896 896"
    }, [
      /*#__PURE__*/_createElementVNode("path", { d: "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z" })
    ])
  ])
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Acessar")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-lg-16 ant-col-xl-16 ui-imagem-login" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/static/img/bg-commerce.jpg" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_alert = _resolveComponent("a-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state.informarParceiro)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Login"))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "ui-login-logo",
                src: _ctx.state.parceiroIdentificado.logo
              }, null, 8, _hoisted_6)),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.state.mensagemAlerta)
              ? (_openBlock(), _createBlock(_component_a_alert, {
                  key: 0,
                  message: _ctx.state.mensagemAlerta,
                  banner: ""
                }, null, 8, ["message"]))
              : _createCommentVNode("", true),
            _hoisted_8,
            (_ctx.state.informarParceiro)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, [
                      _hoisted_13,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.parceiro) = $event)),
                        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args)), ["enter"])),
                        type: "text",
                        class: "ant-input",
                        placeholder: "Informe o seu código"
                      }, null, 544), [
                        [_vModelText, _ctx.state.parceiro]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("span", _hoisted_17, [
                  _hoisted_18,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.dadosLogin.email) = $event)),
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args)), ["enter"])),
                    type: "text",
                    class: "ant-input",
                    placeholder: "Digite seu E-mail"
                  }, null, 544), [
                    [_vModelText, _ctx.state.dadosLogin.email]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.dadosLogin.senha) = $event)),
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.efetuarLogin && _ctx.efetuarLogin(...args)), ["enter"])),
                    type: "password",
                    class: "ant-input",
                    placeholder: "Digite sua Senha"
                  }, null, 544), [
                    [_vModelText, _ctx.state.dadosLogin.senha]
                  ])
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "ui-button -primary ui-full",
              style: {"margin-top":"18px"},
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.efetuarLogin()))
            }, _hoisted_25)
          ])
        ])
      ]),
      _hoisted_26
    ])
  ]))
}